<template>
  <div>  
    <ScoreAwardOne :row="row.start" :list="row.list" :start="row.start.subject" v-if="row.start.award_show_type == 2"></ScoreAwardOne>
    <ScoreAwardList :row="row.start" :list="row.list" :start="row.start.subject" v-if="row.start.award_show_type == 1"></ScoreAwardList>


  </div>
</template>

<script>
import {Toast} from "vant"; 
import ScoreAwardOne from "@/components/score/ScoreAwardOne.vue"; 
import ScoreAwardList from "@/components/score/ScoreAwardList.vue"; 
export default {
  name: "ScoreShow2",
  data: function () {
    return { 
      row: {
        start: {
          award_show_type: 0,
          subject:{
            
          }
        },
        list: [], 
      }
    }
  },
  components: {
    ScoreAwardOne,ScoreAwardList
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch() 
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this; 
      let url = '/api/dscore/awardShowInfo'
      that.$api.post(url, {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
          Toast(res.msg)
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScoreShow3.vue?1ec28fc0